export var Environment;
(function (Environment) {
    Environment["Prod"] = "PROD";
    Environment["ProdInternal"] = "PROD_INTERNAL";
    Environment["Stage"] = "STAGE";
    Environment["EnvironmentUnspecified"] = "ENVIRONMENT_UNSPECIFIED";
})(Environment || (Environment = {}));
